import type { TranslationFileFormat, TranslationFormat } from './ts/Translations';

const en: TranslationFormat[] = [
	['cta.contact', 'Contact us'],
	['cta.getInTouch', 'Get in touch'],
	['cta.playVideo', 'Play video'],
	['section.about', 'About'],
  ['section.about-unizone', 'About Unizone'],
	['section.benefits', 'Benefits'],
	['section.modules', 'Modules'],
	['section.functions', 'Functions'],
	['section.services', 'Our Services'],
	['section.references', 'References']
];

const _default: TranslationFormat[] = [
	['cta.contact', 'Kontaktovat'],
	['cta.getInTouch', 'Ozvěte se nám'],
	['cta.playVideo', 'Přehrát video'],
	['section.about', 'O aplikaci'],
	['section.about-unizone', 'O Unizone'],
	['section.benefits', 'Přínosy'],
	['section.modules', 'Moduly'],
	['section.functions', 'Funkce'],
	['section.services', 'Naše služby'],
	['section.references', 'Reference']
];

export const data = {
	en: en,
	default: _default
};
